window.sfDocumentReady([
  'route-conditions-recently-reviewed',
  'route-conditions-pending-reviews'
], () => {
  // initialize data table
  window.setupDatatable('.js-datatable', 'asc');

  $('.condition-status').change(function() {
    const status = $(this).val(); // status
    const type = $(this).data('type'); // customer or supplier
    const conditionId = $(this).data('condition-id'); // model id
    const data = {status, type, conditionId}

    window.httpPost('/api/condition/status-update', data, {
      success: () => notifyBox('Saved', 'Condition status updated', 'success'),
      error(response, status, error) {
        console.log(response);
      }
    });
  });

  function toggleModal()
  {
    const modal = document.querySelector('.modal');
    modal.classList.toggle('hidden');
    modal.classList.toggle('opacity-0');
  }

  /**
   * Retrieves data and sends the condition update request
   * @param conditionSelectId
   */
  function updateStatus(conditionSelectId)
  {
    // get values from modal hidden input
    const conditionElement = $(`#${conditionSelectId}`);
    const applicationId = conditionElement.data('application-id');
    const status = conditionElement.val(); // status: received, pending-reviews etc
    const type = conditionElement.data('type'); // customer or supplier
    const conditionId = conditionElement.data('condition-id'); // model id
    const conditionName = conditionElement.data('condition-name'); // filename
    const comment = $('#condition_comment').val();
    const data = {
      applicationId,
      status,
      type,
      conditionId,
      conditionName,
      comment
    }

    // status update for pending and recent reviews
    window.httpPost('/api/condition/status-update', data, {
      success: () => {
        $('.js-modal-update-success').removeClass('hidden');
      },
      complete: () => location.reload(),
      error(response) {
        console.log(response);
      }
    });
  }

  /**
   * prepare the condition status data and show the modal
   */
  $('.js-condition-status').change(function() {
    // get the id of the triggered select element
    // then place the id in a hidden text element
    const conditionSelectId = $(this).attr('id');
    $('#temp-condition-id').val(conditionSelectId);

    // only add comments to partially_received(2) and not_received(3) status
    const status = $(this).val();
    if (status === '2' || status === '3') {
      // hides the modal success icon
      $('.js-modal-update-success').addClass('hidden');

      // show the condition comment modal
      toggleModal();

    } else {
      // default condition update
      // clear the condition comment to ensure it does not
      // contain unrelated comments
      $('#condition_comment').val('');
      updateStatus(conditionSelectId);
    }
  });

  /**
   * Executes update request for the condition status
   */
  $('.js-modal-save').click(function(){
    // run the conditions status update
    let conditionSelectId = $('#temp-condition-id').val();
    updateStatus(conditionSelectId);
  });

  /**
   * Hides modal and clears the temp condition hidden element
   */
  $('.js-modal-cancel').click(function(){
    toggleModal();
    $('#temp-condition-id').val('');

    // clear the modal comment text area
    $('#condition_comment').val('');
  });

  /**
   * closes the modal window
   */
  $('.js-modal-close').click(function() {
    toggleModal();
  });

  /**
   * Multi download event
   * Creates an anchor element to attach the downloadable files
   */
  $('.js-download-condition-link').click(function(e) {
    e.preventDefault();

    const conditionName = $(this).data('condition-name');
    const jsDownloadFilesElement = $(`.js-download-files-${conditionName}`);
    const jsonFiles = jsDownloadFilesElement.val();

    window.downloadLinks(JSON.parse(jsonFiles));
  });
});
